export enum TriviaRoundTemplates {
  default = 'TriviaMatic Default Round Template',
  ctm = 'Modified City Trivia Round Template',
  ct = 'City Trivia Round Template',
  warfare = 'Trivial Warfare',
}
